import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

const BASE = `${API_URL}/action-items`;

getAll.operation = 'READ';
export function getAll() {
    return get(BASE);
}
